import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  noteDialog: {
    width: 400,
  },
});

export default useStyles;